var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 231,
    viewBox: "0 0 428 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.259,
    y: 0.707107,
    width: 162,
    height: 162,
    transform: "rotate(45 115.259 0.707107)",
    stroke: "url(#paint0_linear_160_15)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158.017,
    y: 0.707107,
    width: 162,
    height: 162,
    transform: "rotate(45 158.017 0.707107)",
    stroke: "url(#paint1_linear_160_15)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199.017,
    y: 0.707107,
    width: 162,
    height: 162,
    transform: "rotate(45 199.017 0.707107)",
    stroke: "url(#paint2_linear_160_15)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 239.017,
    y: 0.707107,
    width: 162,
    height: 162,
    transform: "rotate(45 239.017 0.707107)",
    stroke: "url(#paint3_linear_160_15)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 279.017,
    y: 0.707107,
    width: 162,
    height: 162,
    transform: "rotate(45 279.017 0.707107)",
    stroke: "url(#paint4_linear_160_15)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 319.017,
    y: 0.707107,
    width: 162,
    height: 162,
    transform: "rotate(45 319.017 0.707107)",
    stroke: "url(#paint5_linear_160_15)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 359.017,
    y: 0.707107,
    width: 162,
    height: 162,
    transform: "rotate(45 359.017 0.707107)",
    stroke: "url(#paint6_linear_160_15)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_15",
    x1: 196.759,
    y1: 0,
    x2: 196.759,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_15",
    x1: 239.517,
    y1: 0,
    x2: 239.517,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_160_15",
    x1: 280.517,
    y1: 0,
    x2: 280.517,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_160_15",
    x1: 320.517,
    y1: 0,
    x2: 320.517,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_160_15",
    x1: 360.517,
    y1: 0,
    x2: 360.517,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_160_15",
    x1: 400.517,
    y1: 0,
    x2: 400.517,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_160_15",
    x1: 440.517,
    y1: 0,
    x2: 440.517,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B37E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup34);
export default __webpack_public_path__ + "static/media/group-34.3c746bd58583920e896ae790fe30a687.svg";
export { ForwardRef as ReactComponent };